import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { PatientReturnConfigQuery, PatientReturnConfigQueryVariables } from '@/shared/api';
import PATIENT_RETURN_CONFIG_QUERY from '../queries/patientReturnConfig';

/**
 * Loads the configuration driving the patient-return workflow. Runs the patientReturnConfig query and throws the first GraphQL error only when no configuration came back.
 *
 * @returns A promise resolving to the patient-return configuration.
 */
const fetchPatientReturnConfig = async () => {
  const client = createClient();
  const result = await client.query<PatientReturnConfigQuery, PatientReturnConfigQueryVariables>({
    query: PATIENT_RETURN_CONFIG_QUERY,
  });
  const { data, errors } = result;
  const { patientReturnConfig } = data;
  if (_.isNil(patientReturnConfig) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return patientReturnConfig;
};

export default fetchPatientReturnConfig;
